var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcColoredAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Aler-01"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 5",
    opacity: 0.5,
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#DFE2EB"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 6",
    cx: 44.0002,
    cy: 44.0007,
    r: 26.6316,
    fill: "white",
    stroke: "#00193C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 121",
    d: "M41.1103 46.6501L39.5497 34.6116C39.2017 31.9267 41.2925 29.5473 43.9999 29.5473C46.7073 29.5473 48.7982 31.9267 48.4501 34.6116L46.8896 46.6501C46.7013 48.1024 45.4644 49.1894 43.9999 49.1894C42.5355 49.1894 41.2985 48.1024 41.1103 46.6501Z",
    fill: "#0E5CF4",
    stroke: "#00193C",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1043",
    x: 40.5264,
    y: 52.1055,
    width: 6.94736,
    height: 6.94737,
    rx: 3.47368,
    fill: "#0E5CF4",
    stroke: "#00193C",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcColoredAlert);
export default __webpack_public_path__ + "static/media/ic-colored-alert.b3a41e72a79018416a7cf82c1a659846.svg";
export { ForwardRef as ReactComponent };